module.exports = __webpack_public_path__ + "static/media/icon-pen.ef017388.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-pen.svg
// module id = ./src/assets/images/icon-pen.svg
// module chunks = 0